<app-header />
<div class="body">
  <router-outlet></router-outlet>
  <ngx-spinner type="ball-scale-multiple" />
</div>
